import axios from 'axios';
import { cacheData } from './offlineCache';

const API_URL = process.env.REACT_APP_API_URL || '';
const DAYS_AHEAD = 14;
const MAX_GIGS = 5;
const MIN_GAP_MS = 5 * 60_000;

let lastRun = 0;

// Saves the set lists (with lyrics and chords) of the live gig and the next couple of weeks' gigs,
// so the teleprompter works at a no-signal venue even if nobody opened that set list beforehand.
// Also saves the whole song library, for songs added to a set on the night.
// Best-effort and throttled: called whenever the gigs list loads with signal.
export async function saveUpcomingSetLists(gigs) {
  if (Date.now() - lastRun < MIN_GAP_MS) return;
  lastRun = Date.now();

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const horizon = today.getTime() + DAYS_AHEAD * 86_400_000;
  const dayOf = g => new Date(`${String(g.gig_date).split('T')[0]}T00:00:00`).getTime();
  const wanted = gigs
    .filter(g => g.is_active || (g.gig_date && dayOf(g) >= today.getTime() && dayOf(g) <= horizon))
    .slice(0, MAX_GIGS);

  try {
    const res = await axios.get(`${API_URL}/api/songs`);
    if (Array.isArray(res.data)) await cacheData('songs', res.data);
  } catch {
    // ignore - the next load with signal tries again
  }

  for (const gig of wanted) {
    cacheData(`gig:${gig.id}`, gig);
    try {
      const res = await axios.get(`${API_URL}/api/gigs/${gig.id}/setlist`);
      await cacheData(`setlist:${gig.id}`, res.data);
    } catch {
      // ignore - the next load with signal tries again
    }
  }
}
